import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IKeywordRecommend } from "./types/_keyword";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/keyword';
const keywordApi = {
  realTimeKeywordRecommends(params: any): Promise<AxiosResponse<ResponseData<IKeywordRecommend[]> & PaginationResponse, any>> {
    const url = `${path}-recommend/all`
    return api.get(url, params)
  },
  popularKeywordRecommends(params: any): Promise<AxiosResponse<ResponseData<IKeywordRecommend[]> & PaginationResponse, any>> {
    const url = `${path}/all`
    return api.get(url, params)
  },
}
export default keywordApi
